/**
 * CUSS Status Codes for virtual device components (conveyor/belt, printers, readers).
 * Based on Embross/CUSS specification — statuscodes module.
 */
export enum CussStatusCode {
  OK = 0,
  TIMEOUT = 1,
  WRONG_STATE = 2,
  CANCELLED = 3,
  SOFTWARE_ERROR = 4,
  ALMOST_OUT_OF_TIME = 5,
  OUT_OF_SEQUENCE = 6,

  // Media related (101–110)
  MEDIA_JAMMED = 101,
  MEDIA_MISPLACED = 102,
  MEDIA_PRESENT = 103,
  MEDIA_ABSENT = 104,
  MEDIA_HIGH = 105,
  MEDIA_FULL = 106,
  MEDIA_LOW = 107,
  MEDIA_EMPTY = 108,
  MEDIA_DAMAGED = 109,
  MEDIA_INCOMPLETELY_INSERTED = 110,
  BAGGAGE_PRESENT = 122, // 122-Present
  BAGGAGE_ABSENT = 123, // 123-Absent
  MULTIPLE_BAGGAGE = 127, // Más de una maleta sobre la banda.

  // Data/Format related (201–205)
  FORMAT_ERROR = 201,
  LENGTH_ERROR = 202,
  DATA_MISSING = 203,
  PHYSICAL_ERROR = 204,
  DATA_PRESENT = 205,

  // Hardware/Critical (301–310) — triggers OOS
  CONSUMABLES = 301,
  HARDWARE_ERROR = 302,
  CRITICAL_SOFTWARE_ERROR = 303,
  NOT_REACHABLE = 304,
  NOT_RESPONDING = 305,
  THRESHOLD_ERROR = 306,
  THRESHOLD_USAGE = 307,
  CONFIGURATION_ERROR = 308,
  SESSION_TIMEOUT = 309,
  KILL_TIMEOUT = 310,
}

/** Human-readable labels for CussStatusCode */
export const CussStatusLabel: Record<number, string> = {
  [CussStatusCode.OK]: 'OK',
  [CussStatusCode.TIMEOUT]: 'TIMEOUT',
  [CussStatusCode.WRONG_STATE]: 'WRONG_STATE',
  [CussStatusCode.CANCELLED]: 'CANCELLED',
  [CussStatusCode.SOFTWARE_ERROR]: 'SOFTWARE_ERROR',
  [CussStatusCode.ALMOST_OUT_OF_TIME]: 'ALMOST_OUT_OF_TIME',
  [CussStatusCode.OUT_OF_SEQUENCE]: 'OUT_OF_SEQUENCE',
  [CussStatusCode.MEDIA_JAMMED]: 'MEDIA_JAMMED',
  [CussStatusCode.MEDIA_MISPLACED]: 'MEDIA_MISPLACED',
  [CussStatusCode.MEDIA_PRESENT]: 'MEDIA_PRESENT',
  [CussStatusCode.MEDIA_ABSENT]: 'MEDIA_ABSENT',
  [CussStatusCode.MEDIA_HIGH]: 'MEDIA_HIGH',
  [CussStatusCode.MEDIA_FULL]: 'MEDIA_FULL',
  [CussStatusCode.MEDIA_LOW]: 'MEDIA_LOW',
  [CussStatusCode.MEDIA_EMPTY]: 'MEDIA_EMPTY',
  [CussStatusCode.MEDIA_DAMAGED]: 'MEDIA_DAMAGED',
  [CussStatusCode.MEDIA_INCOMPLETELY_INSERTED]: 'MEDIA_INCOMPLETELY_INSERTED',
  [CussStatusCode.FORMAT_ERROR]: 'FORMAT_ERROR',
  [CussStatusCode.LENGTH_ERROR]: 'LENGTH_ERROR',
  [CussStatusCode.DATA_MISSING]: 'DATA_MISSING',
  [CussStatusCode.PHYSICAL_ERROR]: 'PHYSICAL_ERROR',
  [CussStatusCode.DATA_PRESENT]: 'DATA_PRESENT',
  [CussStatusCode.CONSUMABLES]: 'CONSUMABLES',
  [CussStatusCode.HARDWARE_ERROR]: 'HARDWARE_ERROR',
  [CussStatusCode.CRITICAL_SOFTWARE_ERROR]: 'CRITICAL_SOFTWARE_ERROR',
  [CussStatusCode.NOT_REACHABLE]: 'NOT_REACHABLE',
  [CussStatusCode.NOT_RESPONDING]: 'NOT_RESPONDING',
  [CussStatusCode.THRESHOLD_ERROR]: 'THRESHOLD_ERROR',
  [CussStatusCode.THRESHOLD_USAGE]: 'THRESHOLD_USAGE',
  [CussStatusCode.CONFIGURATION_ERROR]: 'CONFIGURATION_ERROR',
  [CussStatusCode.SESSION_TIMEOUT]: 'SESSION_TIMEOUT',
  [CussStatusCode.KILL_TIMEOUT]: 'KILL_TIMEOUT',
};

/**
 * Conveyor/Belt specific AEA statuses from SD (statusDevice) and BS (bagStatus) fields.
 */
export enum ConveyorStatus {
  NORMAL = 'NORM',
  EMERGENCY = 'EMCY',
  INTRUSION = 'INTR',
  BAG_PRESENT = 'BAGP',
  JAMMED = 'JAM',
  FAULT = 'FALT',
  STOPPED = 'STOP',
}
